import { render, staticRenderFns } from "./CharacterPhysicalAttributes.vue?vue&type=template&id=e3449bce&"
import script from "./CharacterPhysicalAttributes.vue?vue&type=script&lang=js&"
export * from "./CharacterPhysicalAttributes.vue?vue&type=script&lang=js&"
import style0 from "./CharacterPhysicalAttributes.vue?vue&type=style&index=0&id=e3449bce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports